import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NotificationPopup from "./NotificationPopup";

/** Legacy `/notification` URL — open popup and return to home without a separate page. */
function Notification() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true, state: { openNotifications: true } });
  }, [navigate]);

  return null;
}

export default Notification;

export { NotificationPopup };
